const state = {
    selectedFemalePalms: null,
    selectedMalePalms: null,
    selectedCPCrossTypeId: null,
    selectedMatingDesignId: null,
    selectedLocationPrefix: null,
    crossingProgenies: [],
};

const mutations = {
    SET_CP_CROSS_TYPE: (state, data) => {
        state.selectedCPCrossTypeId = data;
    },
    SET_MATING_DESIGN: (state, data) => {
        state.selectedMatingDesignId = data;
    },
    SET_LOCATION_PREFIX: (state, data) => {
        state.selectedLocationPrefix = data;
    },
    SET_FEMALE_PALMS: (state, data) => {
        state.selectedFemalePalms = data;
    },
    SET_MALE_PALMS: (state, data) => {
        state.selectedMalePalms = data;
    },
    SET_PROGENIES: (state, data) => {
        state.crossingProgenies = data;
    },
};

const actions = {
    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/createProgrammeSteps.js